<template>
  <main class="privacy-page">
    <SiteHeader :appLoginUrl="appLoginUrl" />

    <section class="section privacy-top">
      <div class="container">
        <div class="privacy-back">
          <router-link to="/" class="back-link">← Voltar para a página inicial</router-link>
        </div>

        <PrivacyPageHero />
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="privacy-meta card">
          <strong>Versão vigente:</strong>
          <span>4 de junho de 2026</span>
        </div>

        <div class="controller card">
          <div class="controller-title">Identificação da controladora</div>
          <div class="controller-grid">
            <div class="controller-item">
              <strong>Razão social</strong>
              <span>PAULO HENRIQUE DOS SANTOS ANDRADE</span>
            </div>
            <div class="controller-item">
              <strong>CNPJ</strong>
              <span>08.664.531/0001-90</span>
            </div>
            <div class="controller-item">
              <strong>Responsável</strong>
              <span>PAULO HENRIQUE DOS SANTOS ANDRADE - CEO/DESENVOLVEDOR</span>
            </div>
            <div class="controller-item">
              <strong>Contato LGPD</strong>
              <a href="mailto:contato@sidsolucoes.com.br">contato@sidsolucoes.com.br</a>
            </div>
          </div>
        </div>

        <div class="privacy-grid">
          <article class="privacy-card card">
            <h2>1. Identificação e escopo</h2>
            <p>
              Esta Política de Privacidade se aplica ao App Profissionais Android e aos canais oficiais relacionados ao
              ecossistema EasySaúde. A controladora responsável pelos dados é PAULO HENRIQUE DOS SANTOS ANDRADE,
              inscrita no CNPJ sob o nº 08.664.531/0001-90.
            </p>
            <p>
              Este documento descreve, em linguagem objetiva e compatível com a legislação aplicável, como os dados
              pessoais podem ser coletados, utilizados, compartilhados e protegidos.
            </p>
          </article>

          <article class="privacy-card card">
            <h2>2. Dados pessoais tratados</h2>
            <ul>
              <li>Dados de cadastro e identificação, como nome, e-mail e telefone.</li>
              <li>Dados profissionais e de vínculo com clínica, equipe ou conta de acesso.</li>
              <li>Dados de uso e navegação, como telas acessadas, eventos de sessão e interações no aplicativo.</li>
              <li>Dados técnicos do dispositivo, como versão do Android, modelo, IP e identificadores de sessão.</li>
            </ul>
          </article>

          <article class="privacy-card card">
            <h2>3. Finalidades do tratamento</h2>
            <ul>
              <li>Viabilizar autenticação, acesso e manutenção da sessão.</li>
              <li>Executar rotinas operacionais, suporte e atendimento relacionado ao serviço.</li>
              <li>Aprimorar estabilidade, desempenho, segurança e experiência de uso.</li>
              <li>Cumprir obrigações legais, regulatórias e de proteção contra uso indevido.</li>
            </ul>
          </article>

          <article class="privacy-card card">
            <h2>4. Bases e compartilhamento</h2>
            <p>
              O tratamento pode ocorrer com fundamento em hipóteses legais aplicáveis, incluindo execução de contrato,
              legítimo interesse, cumprimento de obrigação legal ou regulatória e, quando necessário, consentimento do
              titular. O compartilhamento é restrito ao estritamente indispensável para operação, suporte, segurança e
              hospedagem do serviço.
            </p>
          </article>

          <article class="privacy-card card">
            <h2>5. Segurança e retenção</h2>
            <p>
              São adotadas medidas técnicas e administrativas razoáveis para reduzir riscos de acesso não autorizado,
              perda, alteração, divulgação ou destruição indevida. Os dados permanecem pelo tempo necessário ao
              atendimento das finalidades informadas e das obrigações legais, contratuais e regulatórias aplicáveis.
            </p>
          </article>

          <article class="privacy-card card">
            <h2>6. Direitos do titular</h2>
            <p>
              Quando aplicável, o titular pode solicitar confirmação de tratamento, acesso, correção, anonimização,
              eliminação, portabilidade, informação sobre compartilhamento e revisão de decisões automatizadas, nos
              termos da legislação vigente, mediante solicitação ao canal de contato indicado nesta página.
            </p>
          </article>

          <article class="privacy-card card">
            <h2>7. Cookies e identificadores</h2>
            <p>
              O aplicativo e os serviços correlatos podem utilizar identificadores técnicos e tecnologias similares
              para autenticação, manutenção de sessão, métricas de estabilidade e melhoria da experiência de uso.
            </p>
          </article>

          <article class="privacy-card card">
            <h2>8. Atualizações desta política</h2>
            <p>
              Esta política poderá ser revista a qualquer momento para refletir alterações operacionais, técnicas ou
              legais. A versão mais recente permanecerá disponível nesta página.
            </p>
          </article>

          <article class="privacy-card card privacy-card-wide">
            <h2>9. Canais oficiais de contato</h2>
            <p>
              Para assuntos de privacidade, LGPD e exercício de direitos do titular, utilize o contato oficial
              informado abaixo. Os demais canais institucionais seguem disponíveis para operação, suporte e acesso ao
              ecossistema EasySaúde.
            </p>
            <div class="contact-list">
              <div class="contact-item">
                <strong>Responsável</strong>
                <span>PAULO HENRIQUE DOS SANTOS ANDRADE - CEO/DESENVOLVEDOR</span>
              </div>
              <div class="contact-item">
                <strong>Contato LGPD</strong>
                <a href="mailto:contato@sidsolucoes.com.br">contato@sidsolucoes.com.br</a>
              </div>
              <div class="contact-item">
                <strong>Portal do cliente</strong>
                <a :href="appLoginUrl" target="_blank" rel="noopener noreferrer">{{ appLoginUrl }}</a>
              </div>
              <div class="contact-item">
                <strong>Site institucional</strong>
                <a href="https://sidsolucoes.com" target="_blank" rel="noopener noreferrer">sidsolucoes.com</a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import PrivacyPageHero from '../components/PrivacyPageHero.vue'
import SiteHeader from '../components/SiteHeader.vue'

const DEFAULT_APP_LOGIN_URL = 'https://app.easysaude.click'

export default {
  name: 'PrivacyPolicyPage',
  components: {
    PrivacyPageHero,
    SiteHeader
  },
  data() {
    return {
      appLoginUrl: process.env.VUE_APP_APP_LOGIN_URL || DEFAULT_APP_LOGIN_URL
    }
  },
  mounted() {
    document.title = 'Política de Privacidade | EasySaúde'
  }
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
}

.privacy-top {
  padding-top: 22px;
  padding-bottom: 22px;
  background: radial-gradient(900px 420px at 20% 0%, rgba(77, 186, 135, 0.14) 0%, rgba(77, 186, 135, 0) 60%),
    linear-gradient(180deg, rgba(15, 23, 42, 0) 0%, rgba(15, 23, 42, 0.02) 100%);
}

.privacy-back {
  margin-bottom: 14px;
}

.back-link {
  color: var(--easy-muted);
  text-decoration: none;
  font-weight: 700;
  border-bottom: 1px dashed rgba(100, 116, 139, 0.35);
}

.back-link:hover {
  color: var(--easy-dark);
  border-bottom-color: rgba(77, 186, 135, 0.7);
}

.privacy-meta {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}

.controller {
  margin-bottom: 20px;
  padding: 20px 22px;
  border: 1px solid rgba(77, 186, 135, 0.2);
  background: linear-gradient(180deg, rgba(77, 186, 135, 0.06), rgba(255, 255, 255, 1));
}

.controller-title {
  font-weight: 950;
  color: var(--easy-dark);
  margin-bottom: 14px;
}

.controller-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.controller-item {
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.controller-item strong {
  display: block;
  margin-bottom: 6px;
  color: var(--easy-dark);
  font-size: 13px;
}

.controller-item span,
.controller-item a {
  color: var(--easy-muted);
  line-height: 1.6;
  font-size: 14px;
  text-decoration: none;
  word-break: break-word;
}

.privacy-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.privacy-card {
  padding: 22px;
}

.privacy-card-wide {
  grid-column: 1 / -1;
}

.privacy-card h2 {
  margin: 0 0 12px;
  font-size: 22px;
  line-height: 1.2;
}

.privacy-card p,
.privacy-card li,
.contact-item span,
.contact-item a {
  color: var(--easy-muted);
  line-height: 1.7;
  font-size: 15px;
}

.privacy-card ul {
  margin: 0;
  padding-left: 18px;
}

.contact-list {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.contact-item {
  padding: 14px 16px;
  border-radius: 14px;
  background: rgba(77, 186, 135, 0.06);
  border: 1px solid rgba(77, 186, 135, 0.16);
}

.contact-item strong {
  display: block;
  margin-bottom: 6px;
  color: var(--easy-dark);
  font-size: 13px;
}

.contact-item a {
  text-decoration: none;
  word-break: break-word;
}

@media (max-width: 900px) {
  .controller-grid {
    grid-template-columns: 1fr;
  }

  .privacy-grid {
    grid-template-columns: 1fr;
  }

  .privacy-card-wide {
    grid-column: auto;
  }

  .contact-list {
    grid-template-columns: 1fr;
  }
}
</style>
